import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllOrderThunk = createAsyncThunk(
    'order/getAllorder',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllOrder(config);
            //   console.log(response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getOrdeStatisticsThunk = createAsyncThunk(
    'order/orderStatistics',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getOrderStatistics(config);
            //   console.log("staticssssssss",response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const orderDetailsThunk = createAsyncThunk(
    'order/orderDetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getOrderDetails(id);
          
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportOrderThunk = createAsyncThunk(
    'order/exportOrderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllOrder(config);
            //   console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deleteorderThunk = createAsyncThunk(
    'order/deleteorder',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteorder(id);
            dispatch(setorderrefresh())
            toast.success('order deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error('unable to delete order')
        }
    }
);

const orderSlice = createSlice({
    name: 'order',
    initialState: {
        orders: [],
        orderDetails: {},
        orderStatistics: {
            data: {},
            loading: false
        },
        refresh: false,
        loading: false,
        exportLoading: false,
        error: null,
        selectedTab:0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate:'',
    },
    reducers: {

        setorderrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setorderPage: (state, action) => {
            state.page = action.payload
        },
        setOrderSearch: (state, action) => {
            state.search = action.payload
        },
        setOrderStatus: (state, action) => {
            state.status = action.payload
        },
        setOrderFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setOrderToDate: (state, action) => {
            state.toDate = action.payload
        },
        setSelectedTab:(state,action)=>{
            state.selectedTab = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllOrderThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllOrderThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orders = action.payload;
            })
            .addCase(getAllOrderThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(orderDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(orderDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orderDetails = action.payload;
            })
            .addCase(orderDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportOrderThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportOrderThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportOrderThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getOrdeStatisticsThunk.pending, (state) => {
                state.orderStatistics.loading = true;
            })
            .addCase(getOrdeStatisticsThunk.fulfilled, (state, action) => {
                state.orderStatistics.loading = false;
                state.orderStatistics.data = action.payload
            })
            .addCase(getOrdeStatisticsThunk.rejected, (state, action) => {
                state.orderStatistics.loading = false
            })
    },
});

export const { setorderrefresh, setorderPage, setOrderSearch, setOrderStatus, setOrderFromDate,setOrderToDate ,setSelectedTab} = orderSlice.actions
export default orderSlice.reducer;

